import * as React from 'react';
import { StyleSheet, View, useWindowDimensions } from 'react-native';
import { NavigationContainer } from '@react-navigation/native';
import { MainStack } from "./MainStack";
import { AppContext } from "../context/AppContext";
import * as AppConstants from "../context/AppConstants";
import * as AppUtilities from "../context/AppUtilities";
import { CustomKeyboardAvoidingView } from "../components/CustomKeyboardAvoidingView";
import { CustomActivityIndicator } from "../components/CustomActivityIndicator";
import { Search } from "../components/Search";
import { Snackbar, Modal, Portal, Provider as PaperProvider } from 'react-native-paper';
import * as StatusBar from 'expo-status-bar';
import * as AppState from "../context/AppState";
import { ChangeFilter } from '../components/ChangeFilter';
import { Subscribe } from '../components/Subscribe';

const styles = StyleSheet.create({
  modal: {
    alignSelf: "center",
    backgroundColor: "white",
    padding: 20,
    borderRadius: 2,
    shadowColor: "rgba(0, 0, 0, 0.3)",
    shadowOffset: {width: 1, height: 1},
  },
  backdrop: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  image: {
    width: 24,
    height: 24,
  },
  radioText: {
    fontWeight: "bold",
  },
  line: {
    paddingBottom: 15,
    flexWrap: "wrap",
    flexDirection: "row",
    alignItems: "center",
  },
  toggle: {
    marginVertical: 10,
    marginRight: 10,
  },
  searchModal: {
    backgroundColor: 'white',
    width:'90%',
    height: "90%",
    alignSelf: "center",
  },
});

const REACT_NATIVE_NAVIGATION_CONFIG = {
  screens: {
    [AppConstants.SCREENS.HOME]: {
      screens: {
        [AppConstants.SCREENS.MAP_STACK]: {
          initialRouteName: AppConstants.SCREENS.MAP,
          screens: {
            [AppConstants.SCREENS.MAP]: AppConstants.SCREEN_LINKS[AppConstants.SCREENS.MAP],
            [AppConstants.SCREENS.LOCATION_DETAILS]: {
              path: AppConstants.SCREEN_LINKS[AppConstants.SCREENS.LOCATION_DETAILS],
              parse: {
                locationid: (locationid) => parseInt(locationid),
              },
              stringify: {
                locationid: (locationid) => "" + locationid,
              },
            },
            [AppConstants.SCREENS.PRODUCER_DETAILS]: {
              path: AppConstants.SCREEN_LINKS[AppConstants.SCREENS.PRODUCER_DETAILS],
              parse: {
                producer: (producer) => producer,
              },
              stringify: {
                producer: (producer) => producer,
              },
            },
            [AppConstants.SCREENS.PRODUCT_DETAILS]: {
              path: AppConstants.SCREEN_LINKS[AppConstants.SCREENS.PRODUCT_DETAILS],
              parse: {
                productid: (productid) => parseInt(productid),
              },
              stringify: {
                productid: (productid) => "" + productid,
              },
            },
            [AppConstants.SCREENS.FILTER_MAP]: AppConstants.SCREEN_LINKS[AppConstants.SCREENS.FILTER_MAP],
          }
        },
        [AppConstants.SCREENS.DELIVERY_STACK]: {
          initialRouteName: AppConstants.SCREENS.DELIVERY,
          screens: {
            [AppConstants.SCREENS.DELIVERY]: AppConstants.SCREEN_LINKS[AppConstants.SCREENS.DELIVERY],
            [AppConstants.SCREENS.LOCATION_ONLINE_DETAILS]: {
              path: AppConstants.SCREEN_LINKS[AppConstants.SCREENS.LOCATION_ONLINE_DETAILS],
              parse: {
                locationid: (locationid) => parseInt(locationid),
              },
              stringify: {
                locationid: (locationid) => "" + locationid,
              },
            },
            [AppConstants.SCREENS.PRODUCER_ONLINE_DETAILS]: {
              path: AppConstants.SCREEN_LINKS[AppConstants.SCREENS.PRODUCER_ONLINE_DETAILS],
              parse: {
                producer: (producer) => producer,
              },
              stringify: {
                producer: (producer) => producer,
              },
            },
            [AppConstants.SCREENS.PRODUCT_ONLINE_DETAILS]: {
              path: AppConstants.SCREEN_LINKS[AppConstants.SCREENS.PRODUCT_ONLINE_DETAILS],
              parse: {
                productid: (productid) => parseInt(productid),
              },
              stringify: {
                productid: (productid) => "" + productid,
              },
            },
          }
        },
        [AppConstants.SCREENS.EXPLORE_STACK]: {
          screens: {
            [AppConstants.SCREENS.EXPLORE]: AppConstants.SCREEN_LINKS[AppConstants.SCREENS.EXPLORE],
            [AppConstants.SCREENS.PRODUCT_EXPLORE_DETAILS]: {
              path: AppConstants.SCREEN_LINKS[AppConstants.SCREENS.PRODUCT_EXPLORE_DETAILS],
              parse: {
                productid: (productid) => parseInt(productid),
              },
              stringify: {
                productid: (productid) => "" + productid,
              },
            },
            [AppConstants.SCREENS.PRODUCER_EXPLORE_DETAILS]: {
              path: AppConstants.SCREEN_LINKS[AppConstants.SCREENS.PRODUCER_EXPLORE_DETAILS],
              parse: {
                producer: (producer) => producer,
              },
              stringify: {
                producer: (producer) => producer,
              },
            },
          },
        },
        [AppConstants.SCREENS.SUGGEST_STACK]: {
          screens: {
            [AppConstants.SCREENS.ADD_LOCATION]: AppConstants.SCREEN_LINKS[AppConstants.SCREENS.ADD_LOCATION],
          }
        },
        [AppConstants.SCREENS.MORE_STACK]: {
          initialRouteName: AppConstants.SCREENS.MORE,
          screens: {
            [AppConstants.SCREENS.MORE]: AppConstants.SCREEN_LINKS[AppConstants.SCREENS.MORE],
            [AppConstants.SCREENS.FAQ]: AppConstants.SCREEN_LINKS[AppConstants.SCREENS.FAQ],
            [AppConstants.SCREENS.LEARN]: AppConstants.SCREEN_LINKS[AppConstants.SCREENS.LEARN],
            [AppConstants.SCREENS.CREDITS]: AppConstants.SCREEN_LINKS[AppConstants.SCREENS.CREDITS],
            [AppConstants.SCREENS.MORE_CONTACT]: AppConstants.SCREEN_LINKS[AppConstants.SCREENS.MORE_CONTACT],
            [AppConstants.SCREENS.MORE_SUBSCRIBE]: AppConstants.SCREEN_LINKS[AppConstants.SCREENS.MORE_SUBSCRIBE],
            [AppConstants.SCREENS.MORE_ABOUT]: AppConstants.SCREEN_LINKS[AppConstants.SCREENS.MORE_ABOUT],
            [AppConstants.SCREENS.MORE_PRIVACY]: AppConstants.SCREEN_LINKS[AppConstants.SCREENS.MORE_PRIVACY],
            [AppConstants.SCREENS.MORE_POLICIES]: AppConstants.SCREEN_LINKS[AppConstants.SCREENS.MORE_POLICIES],
            [AppConstants.SCREENS.MORE_TERMS]: AppConstants.SCREEN_LINKS[AppConstants.SCREENS.MORE_TERMS],
            [AppConstants.SCREENS.MORE_SUGGEST_LOCATION]: AppConstants.SCREEN_LINKS[AppConstants.SCREENS.MORE_SUGGEST_LOCATION],
            [AppConstants.SCREENS.MORE_LIST_LOCATIONS_NEAR]: AppConstants.SCREEN_LINKS[AppConstants.SCREENS.MORE_LIST_LOCATIONS_NEAR],
            [AppConstants.SCREENS.LOCATION_LIST_DETAILS]: {
              path: AppConstants.SCREEN_LINKS[AppConstants.SCREENS.LOCATION_LIST_DETAILS],
              parse: {
                locationid: (locationid) => parseInt(locationid),
              },
              stringify: {
                locationid: (locationid) => "" + locationid,
              },
            },
            [AppConstants.SCREENS.MORE_DEBUG]: AppConstants.SCREEN_LINKS[AppConstants.SCREENS.MORE_DEBUG],
            [AppConstants.SCREENS.MORE_NEWS]: AppConstants.SCREEN_LINKS[AppConstants.SCREENS.MORE_NEWS],
            [AppConstants.SCREENS.MORE_TEST]: AppConstants.SCREEN_LINKS[AppConstants.SCREENS.MORE_TEST],
            [AppConstants.SCREENS.ALL_PRODUCTS]: AppConstants.SCREEN_LINKS[AppConstants.SCREENS.ALL_PRODUCTS],
            [AppConstants.SCREENS.ALL_PRODUCERS]: AppConstants.SCREEN_LINKS[AppConstants.SCREENS.ALL_PRODUCERS],
            [AppConstants.SCREENS.FILTER]: AppConstants.SCREEN_LINKS[AppConstants.SCREENS.FILTER],
            [AppConstants.SCREENS.PRODUCTS_ALL_DETAILS]: {
              path: AppConstants.SCREEN_LINKS[AppConstants.SCREENS.PRODUCTS_ALL_DETAILS],
              parse: {
                productid: (productid) => parseInt(productid),
              },
              stringify: {
                productid: (productid) => "" + productid,
              },
            },
          }
        }
      }
    },
    [AppConstants.SCREENS.SEARCH]: AppConstants.SCREEN_LINKS[AppConstants.SCREENS.SEARCH],
  }
};

function getTitle(options, route) {
  if (options && options.title) {
    return options.title + " - Find Humane";
  }
  if (route && route.name) {
    const title = AppConstants.SCREEN_TITLES[route.name];
    if (title) {
      return title + " - Find Humane";
    }
  }
  return "Find Humane";
}

function reducer(prevState, action) {
  switch (action.type) {
    case 'INITIALIZED':
      return {
        ...prevState,
      };
    case 'SIGN_IN_LOCAL':
      return {
        ...prevState,
        loginState: AppConstants.LOGIN_STATE.LOGGED_IN_LOCALLY,
      };
    case 'SIGN_IN_REMOTE':
      return {
        ...prevState,
        loginState: AppConstants.LOGIN_STATE.LOGGED_IN_REMOTELY,
      };
    case 'SIGN_OUT':
      return {
        ...prevState,
        loginState: AppConstants.DEFAULT_LOGIN_STATE,
      };
    case 'SHOW_SNACK':
      return {
        ...prevState,
        snackVisible: true,
        snackText: action.data,
        snackDuration: action.duration ? action.duration : AppConstants.TEMPORARY_SNACK_DEFAULT_DURATION,
        snackButtonText: action.snackButtonText,
        snackButtonCallback: action.snackButtonCallback,
      };
    case 'HIDE_SNACK':
      return {
        ...prevState,
        snackVisible: false,
        snackText: null,
        snackButtonText: null,
        snackButtonCallback: null,
      };
    case 'SHOW_SPINNER':
      return {
        ...prevState,
        showSpinner: true,
      };
    case 'HIDE_SPINNER':
      return {
        ...prevState,
        showSpinner: false,
      };
    case 'TOGGLE_MODAL':
      const newVisibleState = !prevState.modalVisible;
      if (newVisibleState && !AppUtilities.isNullOrUndefined(action.selection)) {
        return {
          ...prevState,
          modalVisible: newVisibleState,
          modalSelection: action.selection,
        };
      } else {
        return {
          ...prevState,
          modalVisible: newVisibleState,
        };
      }
    case 'SET_DEBUG':
      return {
        ...prevState,
        showDebug: action.debug,
      };
  }
}

const INITIAL_STATE = {
  loginState: AppConstants.DEFAULT_LOGIN_STATE,
  snackVisible: false,
  snackText: null,
  snackDuration: null,
  snackButtonText: null,
  snackButtonCallback: null,
  showSpinner: false,
  modalVisible: false,
  modalSelection: 1,
  //showDebug: AppState.getGlobalState(AppConstants.SIMPLE_GLOBAL_STATE.DEFAULT_SHOW_DEBUG),
  showDebug: AppConstants.IS_DEVELOPMENT,
};

export function AppWrapper() {
  const [appLoading, setAppLoading] = React.useState(0);
  const navigationRef = React.useRef();
  const [subscribeVisible, setSubscribeVisible] = React.useState(false);
  const [searchVisible, setSearchVisible] = React.useState(false);
  const [hideSearchLocation, setHideSearchLocation] = React.useState(false);
  const [state, dispatch] = React.useReducer(reducer, INITIAL_STATE);

  React.useEffect(() => {
    const bootstrapAsync = async () => {
      AppUtilities.info("AppWrapper started bootstrap");

      let isLoggedIn = false;

      try {
        if (AppUtilities.getLocalDataRemoteSession()) {
          AppUtilities.info("Remote session exists");
          isLoggedIn = true;
        }
      } catch (e) {
        AppUtilities.handleException(e, "AppWrapper.bootstrapAsync load stored state");
      }

      try {
        //AppUtilities.info("Config: " + AppUtilities.toJSONPretty(Constants.expoConfig.extra.test));
      } catch (e) {
        AppUtilities.handleException(e, "AppWrapper.bootstrapAsync extra processing");
      }

      //AppUtilities.info("Finished bootstrap2");

      if (isLoggedIn) {
        dispatch({ type: 'SIGN_IN_REMOTE' });
      } else {
        dispatch({ type: 'SIGN_IN_LOCAL' });
      }

      setAppLoading(1);
    };

    bootstrapAsync();
  }, []);

  if (AppUtilities.isWeb()) {
    const escFunction = React.useCallback((event) => {
      if (event.key === "Escape") {
        if (searchVisible) {
          setSearchVisible(false);
        }
        if (subscribeVisible) {
          setSubscribeVisible(false);
        }
      }
    }, [searchVisible, subscribeVisible]);

    React.useEffect(() => {
      document.addEventListener("keydown", escFunction, false);

      return () => {
        document.removeEventListener("keydown", escFunction, false);
      };
    }, [escFunction, searchVisible, subscribeVisible]);
  }

  const onLayoutRootView = React.useCallback(async () => {
    //AppUtilities.info("AppWrapper.onLayoutRootView appLoading = " + appLoading);

    if (appLoading == 1) {
      try {
        if (!AppUtilities.isWeb()) {
          AppUtilities.info("Configuring StatusBar");
        }
  
        //<StatusBar style="dark" backgroundColor="#ffffff" />
        StatusBar.setStatusBarStyle("dark");
        if (AppUtilities.isAndroid()) {
          StatusBar.setStatusBarBackgroundColor("#ffffff", false);
        }
      } catch (e) {
        AppUtilities.handleException(e, "AppWrapper.onLayoutRootView");
      }

      setAppLoading(2);
    }
  }, [appLoading]);

  React.useEffect(() => {
    //AppUtilities.info("AppWrapper.useEffect appLoading = " + appLoading);
    if (appLoading == 2) {
      async function checkSubscribePopup() {
        if (await AppState.shouldPopUpSubscribe())
        {
          setTimeout(
            () => {
              setSubscribeVisible(true);
            },
            AppConstants.SUBSCRIBE_POPUP_DELAY_MILLISECONDS
          );
        }
      }
      checkSubscribePopup();
    }
  }, [appLoading]);

  function showSpinner(text, duration) {
    dispatch({ type: 'SHOW_SPINNER' });
  }

  function hideSpinner(text, duration) {
    dispatch({ type: 'HIDE_SPINNER' });
  }

  function hideSnack() {
    if (state.snackVisible) {
      dispatch({ type: 'HIDE_SNACK' });
    }
  }

  function showSnack(text, duration, snackButtonText, snackButtonCallback) {
    if (!snackButtonText) {
      snackButtonText = "OK";
    }
    if (!snackButtonCallback) {
      snackButtonCallback = hideSnack;
    }
    dispatch({ type: 'SHOW_SNACK', data: text, duration: duration, snackButtonText: snackButtonText, snackButtonCallback: snackButtonCallback });
  }

  function showPermanentSnack(text, snackButtonText, snackButtonCallback) {
    showSnack(text, Number.POSITIVE_INFINITY, snackButtonText, snackButtonCallback);
  }

  function showTemporarySnack(text, snackButtonText, snackButtonCallback, duration) {
    if (!duration) {
      duration = AppConstants.TEMPORARY_SNACK_DEFAULT_DURATION;
    }
    showSnack(text, duration, snackButtonText, snackButtonCallback);
  }

  function toggleModal(selection) {
    dispatch({ type: 'TOGGLE_MODAL', selection: selection });
  }

  /*
  function isSignedIn() {
    return state.loginState != AppConstants.LOGIN_STATE.LOGGED_OUT;
  }

  async function login_or_register(user, password, login_only) {
    try {
      hideSnack();
      showSpinner();

      const result = await AppUtilities.fetchUnauthorized(
        "AppWrapper.login_or_register",
        AppUtilities.createRequestUrl("/find_humane/api/login_or_register"),
        "POST",
        {
          email: user,
          password: password,
          login_only: login_only,
        },
      );

      if (result.body) {
        await AppUtilities.login(result.body);
        dispatch({ type: 'SIGN_IN_REMOTE' });
      } else {
        throw new Error("Result body not found");
      }
    } catch (e) {
      AppUtilities.handleException(e, "AppWrapper.bootstrapAsync login_or_register");
      showPermanentSnack(AppUtilities.getErrors(e));
      return e;
    } finally {
      hideSpinner();
    }
    return null;
  }

  async function forgotPassword(email) {
    try {
      hideSnack();
      showSpinner();

      const result = await AppUtilities.fetchUnauthorized(
        "AppWrapper.forgotPassword",
        "/api/forgot_password",
        "POST",
        {
          "email": email,
        },
      );

      if (result.body) {
        return null;
      } else {
        throw new Error("Result body not found");
      }
    } catch (e) {
      AppUtilities.handleException(e, "AppWrapper.bootstrapAsync forgotPassword");
      showPermanentSnack(AppUtilities.getErrors(e));
      return e;
    } finally {
      hideSpinner();
    }
  }
  */

  const appContext = React.useMemo(
    () => (
      {
        /*
        register: async (data) => {
          return await login_or_register(data.username, data.password, false);
        },
        signIn: async (data) => {
          return await login_or_register(data.username, data.password, true);
        },
        signOut: async () => {
          try {
            await AppUtilities.logout();
          } catch (e) {
            AppUtilities.handleException(e, "AppWrapper.bootstrapAsync signOut");
            showPermanentSnack(e.toString());
          }
          dispatch({ type: 'SIGN_OUT' })
        },
        forgotPassword: async (data) => {
          return await forgotPassword(data.username);
        },
        isSignedIn: () => isSignedIn(),
        */
        setDebug: async (debug) => {
          dispatch({ type: 'SET_DEBUG', debug: debug });
        },
        isLoading: () => appLoading == 0,
        showPermanentSnack: showPermanentSnack,
        showTemporarySnack: showTemporarySnack,
        hideSnack: hideSnack,
        showSpinner: showSpinner,
        hideSpinner: hideSpinner,
        getLoginState: () => state.loginState,
        getShowDebug: () => state.showDebug,
        toggleModal: toggleModal,
        showSearch: (hideLocationSearch) => {
          setHideSearchLocation(hideLocationSearch);
          setSearchVisible(true);
        }
      }
    ),
    [state]
  );

  if (appLoading == 0) {
    return null;
  } else {
    return (
      <View
        style={AppConstants.STYLES.flex1}
        onLayout={onLayoutRootView}
      >
        <NavigationContainer
          documentTitle={{
            formatter: getTitle
          }}
          ref={navigationRef}
          linking={{
            enabled: true,
            prefixes: ['https://findhumane.com', 'https://*.findhumane.com'],
            config: REACT_NATIVE_NAVIGATION_CONFIG,
          }}
        >
          <AppContext.Provider value={appContext}>
            <PaperProvider theme={AppConstants.REACT_NATIVE_PAPER_THEME}>
              <CustomKeyboardAvoidingView>
                <MainStack />
                <Snackbar
                  visible={state.snackVisible}
                  onDismiss={hideSnack}
                  action={{
                    label: state.snackButtonText,
                    onPress: state.snackButtonCallback,
                  }}
                  wrapperStyle={AppConstants.STYLES.snackWrapper}
                  duration={state.snackDuration}
                >
                  {state.snackText}
                </Snackbar>
                <CustomActivityIndicator
                  hide={!state.showSpinner}
                  absoluteCenter={true}
                  dark={true}
                />
                <Portal>
                  <Modal
                    visible={state.modalVisible}
                    onDismiss={toggleModal}
                  >
                    <ChangeFilter closePopup={toggleModal} />
                  </Modal>
                </Portal>
                <Portal>
                  <Modal
                    visible={subscribeVisible}
                    onDismiss={() => setSubscribeVisible(false)}
                  >
                    <Subscribe closePopup={() => setSubscribeVisible(false)} />
                  </Modal>
                </Portal>
                <Portal>
                  <Modal
                    visible={searchVisible}
                    onDismiss={() => setSearchVisible(false)}
                    //style={{ width: width, height: height }}
                    contentContainerStyle={styles.searchModal}
                  >
                    <Search setSearchVisible={setSearchVisible} hideLocationSearch={hideSearchLocation} />
                  </Modal>
                </Portal>
              </CustomKeyboardAvoidingView>
            </PaperProvider>
          </AppContext.Provider>
        </NavigationContainer>
      </View>
    );
  }
}
